import { registerComponent } from '@gig/magic-common';
import IconComponent from './icon.vue.js';

var Icon = registerComponent(IconComponent);

export { Icon };
